
export enum Periods {
  Current = 'Current period',
  Previous = 'Last period',
  Next = 'Next period'
}
